import styled from 'styled-components';

import { StatusBox } from '@components/BookingProcessModal/components/StatusBox';
import theme from '@styles/theme';

import { FaqMessage } from './FaqMessage';
import { WarningMessage } from './WarningMessage';

export const ThirdStep = () => {
  return (
    <StyledContainer>
      <StatusBox
        title='Step 3: Booking'
        headerColor={'#fff'}
        headerBackground={theme.palette.primary[0]}
        borderColor={theme.palette.primary[0]}
        content={<MainBoxContent />}
      />
      <WarningMessage />
      <FaqMessage />
    </StyledContainer>
  );
};

const MainBoxContent = () => {
  return (
    <StyledMainBoxContent>
      <p>When you receive a booking notice, you’re booked! Congratulations!</p>
      <p>
        After acknowledging your commitment to follow booking instructions and
        inform casting of any emergency changes, you’ll be able to view your
        call time, location, wardrobe notes, and other booking details.
      </p>
    </StyledMainBoxContent>
  );
};

const StyledContainer = styled.div`
  padding: 40px 40px 0px;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: 960px) {
    gap: 12px;
    padding: 20px 20px 24px;
  }
`;

const StyledMainBoxContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  p {
    margin: 0;
  }
`;
